




























import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { UploadOptData, fileServer } from '@/api/common/upload'
import { DynamicAttachData, AttachInfo, getInfo, remove } from '@/api/common/attach'
import { newGuid } from '@/configs/functions'

@Component
export default class DynamicFiles extends Vue {
  public name = 'DynamicFiles'
  @Prop({ default: false })
  public viewModel!: boolean
  @Prop({ default: 0 })
  public referType!: number
  //@Prop({ default: [] })
  public fileList: DynamicAttachData[] = []

  public fileIndex: number = -1
  //每次调用组件都生成一个guid，用来在上传完成后的回传
  public uploadGuid: string = ''
  public getFileUrl(f: DynamicAttachData) {
    return fileServer(f.AttachId, f.TempGuid, f.FileName)
  }
  public getFileInfo(index: number) {
    var f = this.fileList[index]
    getInfo(f.Id, this.referType, f.TempGuid)
      .then((response: { data: AttachInfo }) => {
        const data = response.data
        f.AttachId = data.Id
        f.FilePath = data.Path
        f.FileName = data.Name
        f.FileExt = data.Ext
        f.FileSize = data.Size
        this.$set(this.fileList, index, f)
      })
  }
  public created() {
    if (this.uploadGuid == '') {
      this.uploadGuid = newGuid()
    }
  }
  public mounted() {
    window.eventBus.$on('uploadComplete', (info: any) => {
      if (info.targetId == this.uploadGuid) {
        const opt = info.opt
        this.getFileInfo(this.fileIndex)
      }
    })
  }
  public beforeDestroy() {
    window.eventBus.$off('uploadComplete')
  }
  //打开上传组件
  public showUploader(index: number) {
    if (this.uploadGuid == '') {
      this.uploadGuid = newGuid()
    }
    this.fileIndex = index
    let f = this.fileList[index]
    const curOpt: UploadOptData = {
      isMulti: false,
      exts: f.Exts,
      refId: f.Id,
      refType: this.referType,
      guid: f.TempGuid
    }
    window.eventBus.$emit('openUploader', {
      targetId: this.uploadGuid,
      opt: curOpt
    })
  }
  public delFile(index: number) {
    let f = this.fileList[index]
    const id = f.AttachId
    if (id > 0) {
      this.$confirm(`此操作将永久删除该文件, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          remove(id).then(() => {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            f.AttachId = 0
            f.FilePath = ''
            f.FileName = ''
            f.FileExt = ''
            f.FileSize = 0
            this.$set(this.fileList, index, f)
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    }
  }
  public setData(data: DynamicAttachData[]) {
    this.fileList = []
    this.fileList = data
  }
  public getData() {
    return this.fileList
  }
  public isValid() {
    const errIndex = this.fileList.findIndex(v => v.Required && v.AttachId == 0)
    if (errIndex >= 0) {
      const file = this.fileList[errIndex]
      this.$message({
        message: `请上传${file.AttachName}`,
        type: 'warning'
      })
      return false
    }
    return true
  }
}
